import {
  Landmark, ReceiptText, ShieldCheck, BookOpenCheck, Building2, FileCheck2,
  BriefcaseBusiness, Globe2, Award, Store, Factory, HandPlatter, GraduationCap,
  HeartPulse, ShoppingCart, UtensilsCrossed, Truck, Users, Plane, Network,
  Scale, Clock3, Lock, Target, BadgeCheck, UserCheck,
} from "lucide-react";

export const FIRM = {
  name: "Neeraj Battan & Associates",
  qualification: "Chartered Accountants",
  principal: "CA Neeraj Battan",
  tagline: "Professional Excellence. Trusted Financial Guidance.",
  phone1: "+91 90691 07777",
  phone1Raw: "+919069107777",
  phone2: "+91 97284 08800",
  phone2Raw: "+919728408800",
  email: "ca.neerajbattan@gmail.com",
  addressLines: ["Plot No. 1, 2, 3, KDB Road", "Kurukshetra, Haryana – 136118", "India"],
  domain: "neerajbattanassociates.com",
};

export const WHATSAPP_URL =
  "https://wa.me/919069107777?text=" +
  encodeURIComponent("Hello CA Neeraj Battan, I would like to enquire about your professional services.");

export const MAPS_EMBED_URL =
  "https://www.google.com/maps?q=" +
  encodeURIComponent("Plot No. 1, 2, 3, KDB Road, Kurukshetra, Haryana 136118, India") +
  "&output=embed";

export const MAPS_LINK =
  "https://www.google.com/maps/search/?api=1&query=" +
  encodeURIComponent("Plot No. 1, 2, 3, KDB Road, Kurukshetra, Haryana 136118, India");

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1579487785973-74d2ca7abdd5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBmaW5hbmNlJTIwbHV4dXJ5JTIwb2ZmaWNlJTIwY29uc3VsdGluZyUyMGV4ZWN1dGl2ZSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODkzODgxMTJ8MA&ixlib=rb-4.1.0&q=85",
  boardroom: "https://images.unsplash.com/photo-1571624436279-b272aff752b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjBmaW5hbmNlJTIwbHV4dXJ5JTIwb2ZmaWNlJTIwY29uc3VsdGluZyUyMGV4ZWN1dGl2ZSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODkzODgxMTJ8MA&ixlib=rb-4.1.0&q=85",
  desk: "https://images.unsplash.com/photo-1699621106755-4fe40ce95d64?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHw0fHxjb3Jwb3JhdGUlMjBmaW5hbmNlJTIwbHV4dXJ5JTIwb2ZmaWNlJTIwY29uc3VsdGluZyUyMGV4ZWN1dGl2ZSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODkzODgxMTJ8MA&ixlib=rb-4.1.0&q=85",
  skyline: "https://images.unsplash.com/photo-1610374792793-f016b77ca51a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBmaW5hbmNlJTIwbHV4dXJ5JTIwb2ZmaWNlJTIwY29uc3VsdGluZyUyMGV4ZWN1dGl2ZSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODkzODgxMTJ8MA&ixlib=rb-4.1.0&q=85",
  meeting: "https://images.unsplash.com/photo-1758518731462-d091b0b4ed0d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMG1lZXRpbmclMjBjb25zdWx0YXRpb24lMjBhZHZpc29yJTIwdHJ1c3QlMjBjb3Jwb3JhdGUlMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzg5Mzg4MTExfDA&ixlib=rb-4.1.0&q=85",
  team: "https://images.unsplash.com/photo-1758518731706-be5d5230e5a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMG1lZXRpbmclMjBjb25zdWx0YXRpb24lMjBhZHZpc29yJTIwdHJ1c3QlMjBjb3Jwb3JhdGUlMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzg5Mzg4MTExfDA&ixlib=rb-4.1.0&q=85",
};

export const DISCLAIMER_TEXT =
  "The information available on this website is provided for general informational purposes only and should not be treated as professional advice. The contents of this website do not create a client-professional relationship. Visitors should obtain appropriate professional advice based on their specific facts and circumstances. Neeraj Battan & Associates does not guarantee any particular result or outcome.";

export const ICAI_NOTE =
  "As per the guidelines issued by the Institute of Chartered Accountants of India (ICAI), this website is solely for informational purposes and is not intended for solicitation or advertisement.";

export const ENGAGEMENT_NOTE =
  "Every professional assignment is subject to applicable laws, regulations, professional standards, verification procedures and engagement terms agreed with the client.";

export const SERVICES = [
  {
    slug: "income-tax",
    title: "Income Tax Services",
    icon: Landmark,
    short: "Return filing, tax planning, assessments, notices, TDS and capital gains advisory for individuals and businesses.",
    items: [
      "Income tax return filing",
      "Tax planning and advisory",
      "Income tax assessment assistance",
      "Reply to income tax notices",
      "TDS compliance and return filing",
      "Capital gains advisory",
      "Advance tax calculation",
      "Tax audit assistance",
    ],
  },
  {
    slug: "gst",
    title: "GST Services",
    icon: ReceiptText,
    short: "Registration, return filing, reconciliation, notice replies and end-to-end GST compliance support.",
    items: [
      "GST registration",
      "GST return filing",
      "GST reconciliation",
      "GST notices and replies",
      "GST compliance review",
      "E-way bill advisory",
      "Refund assistance",
      "GST consultancy",
    ],
  },
  {
    slug: "audit-assurance",
    title: "Audit and Assurance",
    icon: ShieldCheck,
    short: "Statutory, tax, internal, stock and compliance audits conducted with rigour and independence.",
    items: [
      "Statutory audit",
      "Tax audit",
      "Internal audit",
      "Stock audit",
      "Concurrent audit",
      "Compliance audit",
      "Financial statement review",
    ],
  },
  {
    slug: "accounting-bookkeeping",
    title: "Accounting and Bookkeeping",
    icon: BookOpenCheck,
    short: "Dependable books of account, financial statements, payroll support and management reporting.",
    items: [
      "Maintenance of books of accounts",
      "Preparation of financial statements",
      "Accounting supervision",
      "Bank reconciliation",
      "Payroll assistance",
      "Management information reports",
      "Outsourced accounting services",
    ],
  },
  {
    slug: "company-llp",
    title: "Company and LLP Services",
    icon: Building2,
    short: "Incorporation, registration, ROC filings and annual compliance for companies and LLPs.",
    items: [
      "Company incorporation assistance",
      "LLP registration assistance",
      "Partnership firm registration",
      "Annual compliance support",
      "ROC filing assistance",
      "Corporate documentation",
      "Business restructuring advisory",
    ],
  },
  {
    slug: "registration-compliance",
    title: "Business Registration and Compliance",
    icon: FileCheck2,
    short: "PAN, TAN, MSME/Udyam, startup registrations and ongoing statutory compliance management.",
    items: [
      "PAN and TAN assistance",
      "MSME/Udyam registration",
      "Professional tax assistance, where applicable",
      "Startup registration support",
      "Other statutory registrations",
      "Periodic compliance management",
    ],
  },
  {
    slug: "financial-advisory",
    title: "Financial and Business Advisory",
    icon: BriefcaseBusiness,
    short: "Project reports, CMA data, loan documentation, projections and management consultancy.",
    items: [
      "Project reports",
      "CMA data preparation",
      "Loan documentation assistance",
      "Cash-flow projections",
      "Projected financial statements",
      "Financial planning",
      "Business structuring",
      "Management consultancy",
    ],
  },
  {
    slug: "nri-taxation",
    title: "NRI Taxation",
    icon: Globe2,
    short: "NRI returns, property transaction taxation, DTAA guidance and cross-border tax compliance.",
    items: [
      "NRI income tax returns",
      "Property transaction taxation",
      "Capital gains advisory",
      "TDS matters",
      "Repatriation-related tax guidance",
      "Double Taxation Avoidance Agreement guidance",
      "Tax compliance for overseas income",
    ],
  },
  {
    slug: "certificates-reports",
    title: "Certificates and Reports",
    icon: Award,
    short: "Net worth, turnover, solvency, utilisation and other certificates permitted under professional regulations.",
    items: [
      "Net worth certificates",
      "Turnover certificates",
      "Solvency certificates",
      "Utilisation certificates",
      "Financial certifications",
      "Other certificates permitted under applicable professional regulations",
    ],
  },
];

export const INDUSTRIES = [
  { name: "Traders and Retailers", icon: Store },
  { name: "Manufacturers", icon: Factory },
  { name: "Service Providers", icon: HandPlatter },
  { name: "Professionals", icon: BriefcaseBusiness },
  { name: "Startups", icon: Target },
  { name: "Real Estate Businesses", icon: Building2 },
  { name: "Educational Institutions", icon: GraduationCap },
  { name: "Healthcare Businesses", icon: HeartPulse },
  { name: "E-commerce Businesses", icon: ShoppingCart },
  { name: "Restaurants and Hospitality", icon: UtensilsCrossed },
  { name: "Transport and Logistics", icon: Truck },
  { name: "Salaried Individuals and Families", icon: Users },
  { name: "NRIs", icon: Plane },
  { name: "Partnership Firms, LLPs and Companies", icon: Network },
];

export const TRUST_INDICATORS = [
  { title: "Professional Expertise", icon: BadgeCheck, text: "Qualified Chartered Accountancy practice governed by professional standards." },
  { title: "Confidential Consultation", icon: Lock, text: "Client information is handled with strict confidentiality at every stage." },
  { title: "Timely Compliance", icon: Clock3, text: "Structured calendars and reminders so statutory deadlines are not missed." },
  { title: "Client-Focused Solutions", icon: UserCheck, text: "Advice shaped around each client's facts, scale and regulatory position." },
  { title: "Ethical Professional Services", icon: Scale, text: "Practice conducted in line with the ICAI Code of Ethics and applicable law." },
  { title: "Personalised Advisory", icon: Target, text: "Direct access to the principal Chartered Accountant for considered guidance." },
];

export const PROCESS_STEPS = [
  { num: "01", title: "Share Your Requirement", text: "Reach out by call, WhatsApp or the enquiry form and briefly describe what you need assistance with." },
  { num: "02", title: "Consultation and Scope", text: "We discuss your facts, review relevant documents and define the scope, timelines and professional terms." },
  { num: "03", title: "Engagement and Documentation", text: "On acceptance, the engagement is formally documented and the required information is gathered securely." },
  { num: "04", title: "Delivery and Ongoing Support", text: "Work is completed within agreed timelines, with continued support for compliance and follow-up matters." },
];

export const CORE_VALUES = [
  "Integrity",
  "Confidentiality",
  "Professional Excellence",
  "Accuracy",
  "Accountability",
  "Timely Service",
  "Client Commitment",
];

export const BLOG_CATEGORIES = [
  "Income Tax Updates",
  "GST Updates",
  "Due-Date Reminders",
  "Business Compliance",
  "Financial Planning",
  "Startup Guidance",
  "NRI Taxation",
  "Capital Gains",
  "Audit and Accounting",
];

export const CLIENT_TYPES = [
  "Individual",
  "Proprietorship",
  "Partnership Firm",
  "LLP",
  "Company",
  "Startup",
  "NRI",
  "Other",
];

export const CONTACT_METHODS = ["Phone Call", "WhatsApp", "Email"];

export const LEGAL_PAGES = {
  "privacy-policy": {
    title: "Privacy Policy",
    updated: "Last updated: July 2026",
    sections: [
      {
        heading: "Information We Collect",
        body: [
          "When you submit an enquiry through this website, we collect the details you provide — such as your name, mobile number, email address, city, client type, the service you require and your message. We also receive the date and time of your submission.",
          "We do not collect sensitive personal data through this website, and we do not ask for passwords, OTPs or financial account credentials through any form on this site.",
        ],
      },
      {
        heading: "How We Use Your Information",
        body: [
          "The information you provide is used solely to review your enquiry, contact you regarding the professional service requested and maintain internal records of enquiries received.",
          "Your information is not sold, rented or shared with third parties for marketing purposes.",
        ],
      },
      {
        heading: "Confidentiality",
        body: [
          "As a Chartered Accountancy practice, we treat all client and prospective-client information as confidential and handle it in accordance with applicable professional standards and the ICAI Code of Ethics.",
        ],
      },
      {
        heading: "Data Security and Retention",
        body: [
          "Enquiry data is stored in a secured administrative system accessible only to authorised persons. Enquiries are retained for as long as reasonably necessary to respond to and document the communication, after which they may be removed.",
        ],
      },
      {
        heading: "Your Choices",
        body: [
          "You may request correction or deletion of the personal information you have submitted by writing to us at ca.neerajbattan@gmail.com.",
        ],
      },
      {
        heading: "Contact",
        body: [
          "For any privacy-related questions, contact CA Neeraj Battan, Neeraj Battan & Associates, Plot No. 1, 2, 3, KDB Road, Kurukshetra, Haryana – 136118, or email ca.neerajbattan@gmail.com.",
        ],
      },
    ],
  },
  "terms-and-conditions": {
    title: "Terms and Conditions",
    updated: "Last updated: July 2026",
    sections: [
      {
        heading: "Informational Purpose",
        body: [
          "This website is published by Neeraj Battan & Associates, Chartered Accountants, for general informational purposes. Use of this website does not create a client-professional relationship between you and the firm.",
        ],
      },
      {
        heading: "No Solicitation",
        body: [
          "In accordance with the guidelines issued by the Institute of Chartered Accountants of India (ICAI), the contents of this website are not intended to solicit professional work or advertise the services of the firm.",
        ],
      },
      {
        heading: "Professional Engagement",
        body: [
          "Any professional service is rendered only under a separate engagement agreed between the firm and the client, subject to applicable laws, regulations, professional standards, verification procedures and engagement terms.",
        ],
      },
      {
        heading: "Accuracy of Information",
        body: [
          "While reasonable care is taken in preparing the content of this website, laws and regulations change frequently. The firm does not warrant that the content is complete, current or applicable to your circumstances, and accepts no liability for actions taken based on it without specific professional advice.",
        ],
      },
      {
        heading: "Intellectual Property",
        body: [
          "All text, design and material on this website belong to Neeraj Battan & Associates and may not be reproduced without prior written permission.",
        ],
      },
      {
        heading: "Governing Jurisdiction",
        body: [
          "Any dispute arising from the use of this website shall be subject to the exclusive jurisdiction of the courts at Kurukshetra, Haryana, India.",
        ],
      },
    ],
  },
  disclaimer: {
    title: "Website Disclaimer",
    updated: "Last updated: July 2026",
    sections: [
      {
        heading: "General Disclaimer",
        body: [
          "The information available on this website is provided for general informational purposes only and should not be treated as professional advice. The contents of this website do not create a client-professional relationship. Visitors should obtain appropriate professional advice based on their specific facts and circumstances. Neeraj Battan & Associates does not guarantee any particular result or outcome.",
        ],
      },
      {
        heading: "ICAI Compliance",
        body: [
          "As per the guidelines issued by the Institute of Chartered Accountants of India (ICAI), this website is solely for informational purposes and is not intended for solicitation or advertisement. The firm does not claim to be the best, the leading or the number one in any respect, and makes no comparative or superlative claims about its services.",
        ],
      },
      {
        heading: "No Guaranteed Outcomes",
        body: [
          "Nothing on this website guarantees tax savings, refunds, loan approvals, regulatory clearances or any particular result. Outcomes of professional matters depend on the facts of each case and the applicable law.",
        ],
      },
      {
        heading: "External Links",
        body: [
          "This website may contain links to external websites (such as government portals or map services). The firm is not responsible for the content or accuracy of external websites.",
        ],
      },
    ],
  },
  "cookie-policy": {
    title: "Cookie Policy",
    updated: "Last updated: July 2026",
    sections: [
      {
        heading: "What Are Cookies",
        body: [
          "Cookies are small text files placed on your device when you visit a website. They are widely used to make websites function properly and to provide information to site owners.",
        ],
      },
      {
        heading: "Cookies Used on This Website",
        body: [
          "Essential cookies: this website uses a strictly necessary, secure session cookie solely for authorised administrator login to the management dashboard. This cookie is not used for visitors browsing the public website.",
          "Analytics cookies: with your consent, privacy-respecting website analytics may be used to understand overall visitor traffic (pages visited, approximate region and device type) so we can improve the website. Analytics data is aggregated and does not personally identify you.",
        ],
      },
      {
        heading: "Managing Cookies",
        body: [
          "You can control or delete cookies through your browser settings at any time. Declining analytics cookies does not affect your ability to browse this website or submit an enquiry.",
        ],
      },
      {
        heading: "Updates to This Policy",
        body: [
          "This Cookie Policy may be updated from time to time. The revised version will be published on this page with an updated date.",
        ],
      },
    ],
  },
};

export const ARTICLE_DISCLAIMER =
  "This article is published for general informational purposes only and does not constitute professional advice. Tax and regulatory positions depend on the specific facts of each case and the law in force at the relevant time. Please consult a qualified professional before acting on any information contained here.";
